import { z } from 'zod';
import { governanceLifecycleStatusSchema } from './governance-standards-workflows.js';
export { ADR_KEY_MIN_DIGITS, ADR_KEY_PREFIX, ADR_KEY_REGEX, ADR_KEY_TOKEN_REGEX, ADR_TITLE_NUMBER_PREFIX_REGEX, formatAdrKey, normalizeAdrDisplayTitle, normalizeAdrKey, parseAdrKey, } from './adr-key.js';
/**
 * `adrNumber` / `adrKey` are optional in the wire schema so older clients and
 * mock fixtures still parse; the server always fills both from
 * `domain.architecture_decision_records.adr_number`.
 */
const adrCanonicalKeyFields = {
    adrNumber: z.number().int().positive().optional(),
    adrKey: z.string().optional(),
};
export const adrSummarySchema = z.object({
    id: z.string().uuid(),
    ...adrCanonicalKeyFields,
    displayTitle: z.string().nullable(),
    lifecycleStatus: governanceLifecycleStatusSchema.optional(),
    summaryExcerpt: z.string().nullable().optional(),
    updatedAt: z.string().datetime().optional(),
    scopeLevel: z.string().optional(),
    repositoryId: z.string().uuid().nullable().optional(),
    stackProfileId: z.string().uuid().nullable().optional(),
});
export const adrListResponseSchema = z.object({
    items: z.array(adrSummarySchema),
});
export const adrDetailResponseSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    ...adrCanonicalKeyFields,
    displayTitle: z.string().nullable(),
    contentDeferred: z.boolean(),
    lifecycleStatus: governanceLifecycleStatusSchema.optional(),
    summaryExcerpt: z.string().nullable().optional(),
    acceptedAt: z.string().datetime().nullable().optional(),
    updatedAt: z.string().datetime().optional(),
    scopeLevel: z.string().optional(),
    repositoryId: z.string().uuid().nullable().optional(),
    stackProfileId: z.string().uuid().nullable().optional(),
});
//# sourceMappingURL=adrs.js.map